// extracted by mini-css-extract-plugin
export default {"professionSection":"Profession_professionSection__AWPLI","title":"Profession_title__JEk4y","text":"Profession_text__HGjPz"};